import { createStyles, makeStyles } from '@material-ui/core/styles';
import { GridRowsProp, GridColDef, GridComponentProps, GridCellValue, DataGrid } from '@mui/x-data-grid';

export const useTotalRowStyles = makeStyles(() =>
    createStyles({
        headerSortButton: {
            // This is to right align the sort icon
            '& > div > div': {
                justifyContent: 'space-between',
            },
            // We need styling changes to match DataGrid v5 styles until we can upgrade to v5. Can remove after upgrading.
            '& button': {
                display: 'none',
            },
            // We need styling changes to match DataGrid v5 styles until we can upgrade to v5. Can remove after upgrading.
            '&:hover': {
                '& button': {
                    display: 'block',
                },
            },
        },
        root: {
            '& .totalRow': {
                borderBottom: 'none',
                fontWeight: 'bold',
            },
        },
    }),
);

export type DSDataGridCellValue = GridCellValue;

export type DSDataGridRowsProp = GridRowsProp;

export type DSDataGridColDef = GridColDef;

export type DSDataGridProps = GridComponentProps;

export const DSDataGrid = DataGrid;
